// Short labels + TablePill variant slugs for order types. Single source of
// truth so /orders, /orders/[id], and the homepage calendar all render the
// same chip for the same underlying order.

export type OrderTypeKey = "adhoc" | "gift" | "event" | "ll" | "set" | "select"

type Resolved = { label: string; variant: OrderTypeKey }

const SIMPLE_TYPES: Record<string, Resolved> = {
	Order: { label: "Adhoc", variant: "adhoc" },
	Gifting: { label: "Gift", variant: "gift" },
	Event: { label: "Event", variant: "event" },
	"Lunch & Learn": { label: "L&L", variant: "ll" },
}

export function resolveOrderType(order: {
	type?: string | null
	package_type_id?: number | null
}): Resolved {
	if (order?.type === "Daily") {
		return order.package_type_id === 1
			? { label: "Set", variant: "set" }
			: { label: "Select", variant: "select" }
	}
	return SIMPLE_TYPES[order?.type as string] || { label: order?.type || "", variant: "adhoc" }
}
